import API from "../config/api.js";

export const PaymentVoucherService = {
  getBranches() {
    return API.get("/api/inventory/branches");
  },
  getPurchaseOrders() {
    return API.get(`/api/purchaseorder/ponumber`);
  },
  getAllPurchaseOrders() {
    return API.get(`/api/payment_voucher/purchaseOrders`);
  },
  getYears() {
    return API.get("/api/payment_voucher/financialYears");
  },
  getPaymentVoucherList(search, page = 1) {
    return API.get(`/api/payment_voucher/list/se=${search}`, {
      params: { page: page },
    });
  },

  async createPaymentVoucher(data) {
    return API.post("/api/payment_voucher/create", data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },
  async updatePaymentVoucher(uuid, formData) {
    const response = await API.put(
      `/api/payment_voucher/update/${uuid}`,
      formData
    );
    return response.data;
  },
  async getVoucherByUUId(uuid) {
    const response = await API.get(`/api/payment_voucher/info/${uuid}`);
    return response.data;
  },

  async dropMember(uuid) {
    const response = await API.delete(`api/payment_voucher/delete/${uuid}`);
    return response.data;
  },

  async postVoucher(uuid) {
    const response = await API.post(`/api/payment_voucher/post/${uuid}`);
    return response.data;
  },

  async getPOAmount(poId) {
    const response = await API.get(`/api/payment_voucher/poAmount/${poId}`);
    return response.data;
  },
};
